import React, { useEffect, useRef } from 'react';

import { useStickyVisibilityContext } from '../../../../contexts/sticky-visibilty-context/StickyVisibilityContext.mjs';
import { HomeContentEntity } from '../../domain/entities/HomeContentEntity';

import styles from '../styles/MiddleSection.module.scss';

import CustomerReviewsCmp from './CustomerReviewsCmp';
import FeaturedCmp from './FeaturedCmp';
import PorterFootprintsCmp from './PorterFootprintsCmp';

interface MiddleSectionCmpProps {
  data: HomeContentEntity;
}

function MiddleSectionCmp({ data }: MiddleSectionCmpProps): React.ReactElement {
  const { setIsStickyHidden } = useStickyVisibilityContext();
  const containerRef = useRef<HTMLDivElement | null>(null);
  const {
    porter_footprints,
    in_the_news,
    testimonials,
    icons,
    read_article_label,
    in_the_news_title,
  } = data;
  const { redirect_icon, wave_icon, star_icon } = icons;

  useEffect(() => {
    const node = containerRef.current;
    if (!node) return undefined;

    const observer = new IntersectionObserver(
      entries => {
        if (entries[0]?.isIntersecting) {
          setIsStickyHidden(false);
        }
      },
      { rootMargin: '0px 0px', threshold: 0.15 },
    );

    observer.observe(node);
    return (): void => observer.disconnect();
  }, [setIsStickyHidden]);

  return (
    <div className={styles['container']} ref={containerRef}>
      <PorterFootprintsCmp porter_footprints_data={porter_footprints} />
      <CustomerReviewsCmp
        testimonials_data={testimonials}
        wave_icon={wave_icon}
        star_icon={star_icon}
      />
      <FeaturedCmp
        news_articles_data={in_the_news}
        redirect_icon={redirect_icon}
        wave_icon={wave_icon}
        read_article_label={read_article_label}
        title={in_the_news_title}
      />
      <div className={styles['blue-gradient']} />
      <div className={styles['gold-gradient-1']} />
    </div>
  );
}

export default MiddleSectionCmp;
